import React, { createContext, useContext, useState } from 'react';

const translations = {
  lv: {
    nav: {
      home: 'Sākums',
      about: 'Par mums',
      menu: 'Ēdienkarte',
      gallery: 'Galerija',
      reservation: 'Rezervācija',
      contact: 'Kontakti',
      reviews: 'Atsauksmes'
    },
    hero: {
      subtitle: 'Modern Georgian Cuisine',
      cta: 'Rezervēt galdiņu'
    },
    about: {
      title: 'Par mums',
      subtitle: 'Garšu simfonija',
      text1: 'Pavillon de Roze piedāvā modernu gruzīnu virtuvi, kuras konceptu un ēdienkarti izveidojuši divi izcili gruzīnu brenda šefpavāri.',
      text2: 'Luka Khinkiladze — Bocuse d\'Or Euro 2020 dalībnieks, Falstaff Silver Spoon Winner 2025.',
      text3: 'Luka Todua — Gault&Millau Gada jaunais pavārs 2023, ar pieredzi Michelin restorānos.',
      chefsTitle: 'Brenda šefpavāri'
    },
    menu: {
      title: 'Ēdienkarte',
      subtitle: 'Izlases ēdieni',
      categories: {
        starters: 'Uzkodas',
        dough: 'Mīklas izstrādājumi',
        soups: 'Zupas',
        main: 'Pamatēdieni',
        desserts: 'Deserti',
        sides: 'Piedevas'
      }
    },
    gallery: {
      title: 'Galerija',
      subtitle: 'Atmosfēra un garšas'
    },
    reservation: {
      title: 'Rezervācija',
      subtitle: 'Rezervējiet savu galdiņu',
      form: {
        name: 'Vārds',
        phone: 'Tālrunis',
        date: 'Datums',
        time: 'Laiks',
        guests: 'Viesu skaits',
        notes: 'Piezīmes (neobligāti)',
        submit: 'Rezervēt',
        success: 'Rezervācija veiksmīga!',
        successDesc: 'Mēs ar jums sazināsimies, lai apstiprinātu rezervāciju.'
      }
    },
    footer: {
      address: 'Adrese',
      hours: 'Darba laiks',
      hoursText: 'Katru dienu 12:00 - 22:00',
      contact: 'Kontakti',
      rights: 'Visas tiesības aizsargātas'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      menu: 'Menu',
      gallery: 'Gallery',
      reservation: 'Reservation',
      contact: 'Contact',
      reviews: 'Reviews'
    },
    hero: {
      subtitle: 'Modern Georgian Cuisine',
      cta: 'Reserve a Table'
    },
    about: {
      title: 'About Us',
      subtitle: 'A Symphony of Flavors',
      text1: 'Pavillon de Roze offers modern Georgian cuisine with menu and concept created by two exceptional Georgian brand chefs.',
      text2: 'Luka Khinkiladze — Bocuse d\'Or Euro 2020 participant, Falstaff Silver Spoon Winner 2025.',
      text3: 'Luka Todua — Gault&Millau Young Chef of the Year 2023, with Michelin-starred experience.',
      chefsTitle: 'Brand Chefs'
    },
    menu: {
      title: 'Menu',
      subtitle: 'Featured Dishes',
      categories: {
        starters: 'Starters',
        dough: 'Dough & Khinkali',
        soups: 'Soups',
        main: 'Main Courses',
        desserts: 'Desserts',
        sides: 'Sides'
      }
    },
    gallery: {
      title: 'Gallery',
      subtitle: 'Atmosphere & Flavors'
    },
    reservation: {
      title: 'Reservation',
      subtitle: 'Book Your Table',
      form: {
        name: 'Name',
        phone: 'Phone',
        date: 'Date',
        time: 'Time',
        guests: 'Number of Guests',
        notes: 'Notes (optional)',
        submit: 'Reserve',
        success: 'Reservation Successful!',
        successDesc: 'We will contact you to confirm your reservation.'
      }
    },
    footer: {
      address: 'Address',
      hours: 'Opening Hours',
      hoursText: 'Daily 12:00 - 22:00',
      contact: 'Contact',
      rights: 'All rights reserved'
    }
  },
  ru: {
    nav: {
      home: 'Главная',
      about: 'О нас',
      menu: 'Меню',
      gallery: 'Галерея',
      reservation: 'Бронирование',
      contact: 'Контакты',
      reviews: 'Отзывы'
    },
    hero: {
      subtitle: 'Modern Georgian Cuisine',
      cta: 'Забронировать столик'
    },
    about: {
      title: 'О нас',
      subtitle: 'Симфония вкусов',
      text1: 'Pavillon de Roze предлагает современную грузинскую кухню, меню и концепцию которой создали два выдающихся грузинских бренд-шефа.',
      text2: 'Лука Хинкиладзе — участник Bocuse d\'Or Euro 2020, Falstaff Silver Spoon Winner 2025.',
      text3: 'Лука Тодуа — Молодой шеф года Gault&Millau 2023, с опытом в ресторанах Мишлен.',
      chefsTitle: 'Бренд-шефы'
    },
    menu: {
      title: 'Меню',
      subtitle: 'Избранные блюда',
      categories: {
        starters: 'Закуски',
        dough: 'Тесто и хинкали',
        soups: 'Супы',
        main: 'Основные блюда',
        desserts: 'Десерты',
        sides: 'Гарниры'
      }
    },
    gallery: {
      title: 'Галерея',
      subtitle: 'Атмосфера и вкусы'
    },
    reservation: {
      title: 'Бронирование',
      subtitle: 'Забронируйте ваш столик',
      form: {
        name: 'Имя',
        phone: 'Телефон',
        date: 'Дата',
        time: 'Время',
        guests: 'Количество гостей',
        notes: 'Примечания (необязательно)',
        submit: 'Забронировать',
        success: 'Бронирование успешно!',
        successDesc: 'Мы свяжемся с вами для подтверждения брони.'
      }
    },
    footer: {
      address: 'Адрес',
      hours: 'Время работы',
      hoursText: 'Ежедневно 12:00 - 22:00',
      contact: 'Контакты',
      rights: 'Все права защищены'
    }
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('lv');

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
